import React, { useState } from "react";
import "./gallery.css"; // assuming this CSS file

const images = [
  { id: 1, src: "/images/photo1.jpeg", alt: "Photo 1" },
  { id: 2, src: "/images/photo2.jpeg", alt: "Photo 2" },
  { id: 3, src: "/images/photo3.jpeg", alt: "Photo 3" },
  { id: 4, src: "/images/photo4.jpeg", alt: "Photo 4" },
  { id: 5, src: "/images/photo5.jpeg", alt: "Photo 5" },
  { id: 6, src: "/images/photo6.jpeg", alt: "Photo 6" },
  { id: 7, src: "/images/photo7.jpeg", alt: "Photo 7" },
  { id: 8, src: "/images/photo8.jpeg", alt: "Photo 8" },
  { id: 9, src: "/images/photo9.jpeg", alt: "Photo 9" },
  { id: 10, src: "/images/photo10.jpeg", alt: "Photo10" },
  { id: 11, src: "/images/photo11.jpeg", alt: "Photo11" },
  { id: 12, src: "/images/photo12.jpeg", alt: "Photo12" },
  { id: 13, src: "/images/photo13.jpeg", alt: "Photo13" },
  { id: 14, src: "/images/photo14.jpeg", alt: "Photo14" },
  { id: 15, src: "/images/photo15.jpeg", alt: "Photo15" },
  { id: 16, src: "/images/photo16.jpeg", alt: "Photo16" },
  { id: 17, src: "/images/photo17.jpeg", alt: "Photo17" },
  { id: 18, src: "/images/photo18.jpeg", alt: "Photo18" },
  { id: 19, src: "/images/photo19.jpeg", alt: "Photo19" },
  { id: 20, src: "/images/photo20.jpeg", alt: "Photo20" },
  { id: 21, src: "/images/photo21.jpeg", alt: "Photo21" },
  { id: 22, src: "/images/photo22.jpeg", alt: "Photo22" },
  { id: 23, src: "/images/photo23.jpeg", alt: "Photo23" },
  { id: 24, src: "/images/photo24.jpeg", alt: "Photo24" },
  { id: 25, src: "/images/photo25.jpeg", alt: "Photo25" },
  // add your images here
];

function Gallery() {
  const [preview, setPreview] = useState(null);

  const openPreview = (img) => setPreview(img);
  const closePreview = () => setPreview(null);

  return (
    <div className="gallery-container">
      <h1 className="gallery-title">Gallery</h1>
      <div className="gallery-grid">
        {images.map((img) => (
          <div
            key={img.id}
            className="gallery-card"
            tabIndex={0}
            onClick={() => openPreview(img)}
            onKeyDown={(e) => {
              if (e.key === "Enter") openPreview(img);
            }}
          >
            <img className="gallery-image" src={img.src} alt={img.alt} />
          </div>
        ))}
      </div>

      {preview && (
        <div
          className="gallery-preview-modal active"
          onClick={closePreview}
          role="dialog"
          aria-modal="true"
        >
          <div
            className="gallery-preview-content"
            onClick={(e) => e.stopPropagation()}
          >
            <img src={preview.src} alt={preview.alt} />
            <div
              className="gallery-preview-close"
              onClick={closePreview}
              aria-label="Close preview"
            >
              &times;
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Gallery;
